import React from 'react';
import { color, font, space, text } from '../theme';

interface PageHeaderProps {
  title: string;
  // One line under the title: a count or a plain-language summary
  subtitle?: React.ReactNode;
  // Extra content under the title block, e.g. a SearchField
  children?: React.ReactNode;
  // A control at the end of the title row, e.g. the Knesset menu
  action?: React.ReactNode;
  style?: React.CSSProperties;
}

// The large title at the top of a section page (חקיקה, ועדות, …)
const PageHeader = ({ title, subtitle, children, action, style }: PageHeaderProps) => (
  <header style={{ display: 'flex', flexDirection: 'column', gap: space.md, ...style }}>
    <div>
      {action
        ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: space.sm }}><h1 style={text.pageTitle}>{title}</h1>{action}</div>
        : <h1 style={text.pageTitle}>{title}</h1>}
      {subtitle && <div style={{ fontSize: font.label, color: color.textSecondary, marginTop: space.xs }}>{subtitle}</div>}
    </div>
    {children}
  </header>
);

export default PageHeader;
